import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent, AuthLayoutComponent, ViasAuthService } from 'viasng-core';


const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('viasng-core').then(m => m.DashboardModule)
      },
      {
        path: 'framework',
        loadChildren: () => import('./framework/framework.module').then(m => m.FrameworkModule)
      },
      {
        path: 'hr',
        loadChildren: () => import('./hr/hr.module').then(m => m.HrModule)
      },
      {
        path: 'ims',
        loadChildren: () => import('./ims/ims.module').then(m => m.ImsModule)
      },
      {
        path: 'maintenance',
        loadChildren: () => import('./maintenance/maintenance.module').then(m => m.MaintenanceModule)
      },
      // {
      //   path: 'nb-design',
      //   loadChildren: () => import('./nb-design/nb-design.module').then(m => m.NbDesignModule)
      // },
      // {
      //   path: 'nb-marketing',
      //   loadChildren: () => import('./nb-marketing/nb-marketing.module').then(m => m.NbMarketingModule)
      // },
      // {
      //   path: 'nb-planning',
      //   loadChildren: () => import('./nb-planning/nb-planning.module').then(m => m.NbPlanningModule)
      // },
      // {
      //   path: 'nb-production',
      //   loadChildren: () => import('./nb-production/nb-production.module').then(m => m.NbProductionModule)
      // },
      // {
      //   path: 'nb-qc',
      //   loadChildren: () => import('./nb-qc/nb-qc.module').then(m => m.NbQcModule)
      // },
      // {
      //   path: 'ohs',
      //   loadChildren: () => import('./ohs/ohs.module').then(m => m.OhsModule)
      // },
      {
        path: 'planning',
        loadChildren: () => import('./planning/planning.module').then(m => m.PlanningModule)
      },
      {
        path: 'purchasing',
        loadChildren: () => import('./purchasing/purchasing.module').then(m => m.PurchasingModule)
      },
      {
        path: 'repair-design',
        loadChildren: () => import('./repair-design/repair-design.module').then(m => m.RepairDesignModule)
      },
      {
        path: 'repair-marketing',
        loadChildren: () => import('./repair-marketing/repair-marketing.module').then(m => m.RepairMarketingModule)
      },
      {
         path: 'repair-planning',
         loadChildren: () => import('./repair-planning/repair-planning.module').then(m => m.RepairPlanningModule)
      },
      // {
      //   path: 'repair-production',
      //   loadChildren: () => import('./repair-production/repair-production.module').then(m => m.RepairProductionModule)
      // },
      // {
      //   path: 'repair-qc',
      //   loadChildren: () => import('./repair-qc/repair-qc.module').then(m => m.RepairQcModule)
      // },
      {
        path: 'warehouse',
        loadChildren: () => import('./warehouse/warehouse.module').then(m => m.WarehouseModule)
      },
      {
        path: 'sale',
        loadChildren: () => import('./sale/sale.module').then(m => m.SaleModule)
      }
    ],
    canActivate: [ViasAuthService]
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'account',
        loadChildren: () => import('viasng-core').then(m => m.AccountModule)
      },
      {
        path: 'error',
        loadChildren: () => import('viasng-core').then(m => m.ErrorModule)
      }
    ]
  },
  {
    path: 'dashboard',
    redirectTo: '/dashboard/dashboard',
    pathMatch: 'full',
    canActivate: [ViasAuthService]
  },
  {
    path: '**',
    redirectTo: 'error/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: true, useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
